export const DOCUMENT_REFERENCE_TYPE = {
  additionalDocForReport: {
    code: 'additionalDocForReport',
    display: 'Additional Documents For Transmission Report',
  },
  transmissionReportFile: {
    code: 'transmissionReportFile',
    display: 'Transmission report file',
  },
  PatientListsResourceEducation: {
    system: 'http://loinc.org',
    code: 'PatientListsResourceEducation',
    display: 'PatientResourceEducation',
  },
  PatientListsResource: {
    system: 'http://loinc.org',
    code: 'PatientListsResource',
    display: 'PatientResource',
  },
  PatientListsResourceFaq: {
    system: 'http://loinc.org',
    code: 'PatientListsResourceFaq',
    display: 'PatientResourceFaq',
  },
};
